import {Fragment} from 'react';

import i18n from '../../../i18n/i18n';
import {addNewLineBeforeMatches, BREAK_LINE_CHARACTER} from '../utils/addNewLineBeforeMatches';
import {toKeyword} from '../utils/toKeyword';

interface TextWithNewLinesProps {
  text: string;
}

/**
 * This is a product requirement by Cebia workspace. Not the best idea, but PM approved it, even though it's not a good practice and devs were against it.
 */
export function TextWithNewLines(props: TextWithNewLinesProps) {
  const KEYWORDS = [
    toKeyword(i18n.t('exterior')),
    toKeyword(i18n.t('interior')),
    toKeyword(i18n.t('mechanics')),
    toKeyword(i18n.t('conclusion')),
  ];

  const processedText = addNewLineBeforeMatches(props.text, KEYWORDS);
  const lines = processedText.split(BREAK_LINE_CHARACTER);

  return (
    <div>
      {lines.map((line, index) => (
        <Fragment key={index}>
          {line}
          {index < lines.length - 1 && (
            <>
              <br />
              <br />
            </>
          )}
        </Fragment>
      ))}
    </div>
  );
}
